<template>
    <div class="page hotel mx-4">       

<!-- Galeria -->
        <div class="header hotel-carousel position-relative mb-2">            
            <!-- Flickity HTML init -->
            <flickity ref="flickity" :options="flickityOptions" class="gallery">
                <div class="gallery-cell" v-for="(imagen,index) in imagenes" :key="index">
                    <img class="gallery-cell-image flickity-lazyloaded flickity-lazyerror" :src="imagen">                        
                </div>                
            </flickity>
        </div>
<!-- Datos Hotel -->
        <div class="description mx-1">
            <!-- <main class="container"> -->
                <div class="row">
                    <!-- <div class="col-md-8"> -->
                    <div class="col-md-12">
                        <div class="hotel-header-left">
                            <div class="row">
                                <div class="col-md-12 pl-1">
                                    <h5>{{ hotel.name }}</h5>
                                </div>
                                
                            </div>                            
                            <div class="hotel-location text-success">
                                <i class="fas fa-map-marker-alt mr-1"></i>
                                <!-- <img src="img/map-marker-icon.svg" alt="" />  -->
                                {{ hotel.zon }} &nbsp; - &nbsp; <small> {{ hotel.pob }} </small>
                            </div>                                            
                        </div>
                        <div class="hotel-description py-4 border-bottom">
                            <!-- <div class="text-justify" v-html="hotel.des1"></div> -->
                            <!-- <div class="text-justify" v-html="hotel.ani"></div> -->
                            <!-- <p> {{ hotel.ani }} </p>   -->                                    
                        </div>

                        <div class="services-hotel border-bottom">
                            <!-- <h2>Servicios en el hotel</h2>
                            <div class="text-justify" v-html="hotel.ser"></div> -->
                            <!-- <div class="container services-hotel-list">
                                <div class="row">
                                    <div class="service-hotel-item col-xs-6 col-sm-4">
                                        <i class="fas fa-wifi"></i>Piscina
                                    </div>
                                    <div class="service-hotel-item col-xs-6 col-sm-4">
                                        <i class="fas fa-wifi"></i>Spa
                                    </div>
                                    <div class="service-hotel-item col-xs-6 col-sm-4">
                                        <i class="fas fa-paw"></i>No se admiten mascotas
                                    </div>
                                    <div class="service-hotel-item col-xs-6 col-sm-4">
                                        <i class="fas fa-wifi"></i>Adaptado minusválidos
                                    </div>
                                    <div class="service-hotel-item col-xs-6 col-sm-4">
                                        <i class="fas fa-wifi"></i>Playa
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="location border-bottom">
                            <!-- <h2>Situación</h2>
                            <div class="location-map py-2 px-4">
                                <img class="img-fluid" src="/img/map-prince-park.png" alt="" />
                            </div> -->
                        </div>
                    </div>                    
                </div>
            <!-- </main> -->
        </div>

        <!-- Modal Precios -->
        <!-- <hotelPrecios></hotelPrecios> -->

    </div>    
</template>

<script>

import Flickity from 'vue-flickity';
// import hotelPrecios from '@/components/HotelPrecios.vue'

export default {
    name: 'hotel-imagenes',

    components: {
        Flickity, 
        
    },
    data() {
        return {
            //titulo: "INFORMACIÓN HOTEL",

            listaImagen: [],
            
            flickityOptions: {
                autoPlay: true,
                initialIndex: 0,
                prevNextButtons: true,
                pageDots: true,
                freeScroll: true,
                wrapAround: true,
                draggable: false,
                adaptiveHeight: true,
                
            },
            
            slide: 0,
            sliding: null
        }
    },
    computed: {
        hotel() {
            return this.$store.state.hotel;
        },

        imagenes() {
            let url="https://iberopa.com/_abk/lib/imagendb.php?w=123|vc_telefonica|hoteles_img|";
            let A=[];        
            this.hotel.imagenes.split(',').forEach(value => {
                A.push(url+value);                
            });            
            //console.log(A);
            return A;
        },
    },
    methods: {
        async hotel_precios() { 
            await this.$store.dispatch('hotel_precios',this.hotel);
            this.$bvModal.show("modal_hotelPrecios");            
        },
        //galeria
        next() {
            this.$refs.flickity.next();
        },    
        prev() {
            this.$refs.flickity.previous();
        },

        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
    },
    created() {        
        if (this.hotel.id==undefined) {
            this.$router.push('/catalogo');
        }
        //console.log('*hotel_info.created',this.hotel.hot);
    },
    mounted() {        
    },
}
</script>